import { useEffect, useRef, useState } from "react";
import { vocabularize } from "src/Common/vocab";

import _ from "lodash";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  API_URL,
  can,
  downloadFile,
  downloadImage,
  handleError,
  isAccountant,
  isManagerOver,
  isClericalOver,
} from "src/Common/function";
import Button from "src/Components/Button";
import CreateButton from "src/Components/CreateButton";
import DownloadButton from "src/Components/DownloadButton";
import UserService from "src/Services/API/user.service";
import WOService from "src/Services/API/wo.service";
import CreateWoModal from "./Components/createwomodal";
import WOFitlerView from "src/Components/filter/WOFilterView";
import BranchBar from "src/Components/branchbar/BranchBar";
import moment from "moment-timezone";
import { convertToArizonaTime } from "src/Common/common";
import TechnicianService from "src/Services/API/technician.service";
import WoTable, { WO_SCROLL_STORAGE_KEY } from "./Components/WoTable";
import { noteWoCreated } from "src/Pages/KnowledgeBase/kbSession";

function WO() {
  const currentUser = UserService.getCurrentUser();
  // const keyword = useSelector((state) => state.Keyword.keyword);
  const user = UserService.getCurrentUser();
  // Whether the Create dialog is open is mirrored into the URL as ?create=1 — the
  // same place branch, keyword and criteria already live — so the Knowledge Base
  // walkthrough (Azure 416) can read it without reaching into this component.
  const [isCreateOpen, setIsCreateOpenState] = useState(false);
  const [orderArray, setOrderArray] = useState([]);
  const [loadMoreButtonShown, setLoadMoreButtonShown] = useState(false);
  const [filterOpen, setFilterOpen] = useState(false);
  const [sort, setSort] = useState(null);
  // True while a scroll restore is fetching the previously loaded rows.
  const [restoring, setRestoring] = useState(false);

  const [isDownloading, setIsDownloading] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const criteria = searchParams.get("criteria");
  const [branch, setBranch] = useState(() => {
    const param = searchParams.get("branch");
    return param === null ? -1 : Number(param);
  });

  const keyword = searchParams.get("keyword") || "";

  // Open/close writes ?create=1 and the param drives the state, so a reload,
  // the browser Back button and the walkthrough all agree on whether the
  // dialog is open. replace: true keeps it out of the history stack.
  const setIsCreateOpen = (open) => {
    setIsCreateOpenState(open);
    const url = new URLSearchParams(searchParams);
    if (open) url.set("create", "1");
    else url.delete("create");
    navigate(`${location.pathname}?${url.toString()}`, { replace: true });
  };
  useEffect(() => {
    setIsCreateOpenState(searchParams.get("create") === "1");
  }, [searchParams]);

  // Pending scroll restoration coming back from the WO detail page.
  // Holds the saved WO id while pages are auto-loaded until it appears.
  const restoreRef = useRef(null);
  // Bumped on every fresh fetch cycle; responses from an older cycle (e.g.
  // the double fetch caused by branch initialization) are dropped so they
  // cannot overwrite the list or cancel a pending restore.
  const fetchGenRef = useRef(0);

  useEffect(() => {
    const param = searchParams.get("branch");
    setBranch(param === null ? -1 : Number(param));
  }, [searchParams]);

  useEffect(() => {
    fetchGenRef.current += 1;
    const gen = fetchGenRef.current;
    const saved = sessionStorage.getItem(WO_SCROLL_STORAGE_KEY);
    let pending = null;
    try {
      pending = saved ? JSON.parse(saved) : null;
      if (pending && pending.search !== undefined && pending.search !== location.search) {
        // Saved from a different filter/branch context — not restorable here.
        sessionStorage.removeItem(WO_SCROLL_STORAGE_KEY);
        pending = null;
      }
    } catch {
      pending = null;
      sessionStorage.removeItem(WO_SCROLL_STORAGE_KEY);
    }
    restoreRef.current = pending;
    setRestoring(!!pending);
    // A pending restore fetches every previously loaded row in one request.
    const limit = pending?.loadedCount > 0 ? pending.loadedCount : undefined;
    getAllWorkOrder([], { limit }, gen);
    if (criteria) {
      setFilterOpen(true);
    } else {
      setFilterOpen(false);
    }
    console.log("🚀 ~ WO ~ branch:", branch);
  }, [keyword, criteria, sort, branch]);

  const getAllWorkOrder = (previousOrderArray, { limit } = {}, gen = fetchGenRef.current) => {
    // Offset-based continuation: rows deleted from the list can't shift page
    // boundaries the way pageNumber-based pagination could.
    const offset = previousOrderArray.length;
    WOService.getAllWorkOrders(user.id, keyword, 0, JSON.parse(criteria), sort, branch, limit, offset)
      .then((response) => {
        if (gen !== fetchGenRef.current) return;
        if (response.status == 200) {
          let temp = [...previousOrderArray, ...response.data.orders];
          console.log("11111111111L: ", temp);
          setOrderArray(temp);
          setLoadMoreButtonShown(temp.length < response.data.totalCount);

          // Scroll restore is single-shot now: the id is either in this
          // response or the saved entry is stale. WoTable does the scroll.
          if (restoreRef.current) {
            const found = temp.some((order) => order.id === restoreRef.current.id);
            restoreRef.current = null;
            if (!found) {
              sessionStorage.removeItem(WO_SCROLL_STORAGE_KEY);
            }
            setRestoring(false);
          }
        }
      })
      .catch((error) => {
        setRestoring(false);
        handleError(error);
      });
  };

  // Returns the request promise so the modal can keep its submit button
  // disabled until the create settles (double-submit guard).
  const saveWO = (data, primaryTech) => {
    return WOService.createWorkOrder(data)
      .then(async (response) => {
        if (response.status === 201) {
          if (primaryTech) {
            try {
              const res = await TechnicianService.createTechnician({
                woId: response.data.id,
                data: [{ user: primaryTech.id, roleId: 0 }],
                eventUser: currentUser,
              });
            } catch (error) {
              handleError(error);
            }
          }
          setIsCreateOpen(false);
          noteWoCreated(response.data.id);
          toast(vocabularize("Work order created successfully"));
          getAllWorkOrder([]);
        } else {
          toast("something went wrong!");
        }
      })
      .catch((error) => {
        handleError(error);
      });
  };

  const handleLoadMore = () => {
    getAllWorkOrder(orderArray);
  };

  const downloadExcelFile = async () => {
    setIsDownloading(true);
    try {
      await WOService.generateExcelFile(user.id, keyword, JSON.parse(criteria), sort, branch);
      await downloadFile(`${API_URL}/files/${user.company}/reports/${user.id}/WOs_report.xlsx`, "WOs_report.xlsx");
      setIsDownloading(false);
    } catch (error) {
      handleError(error);
    }
  };

  const appendBranchParam = (query, value) => {
    const currentPath = location.pathname;
    const currentSearch = location.search;

    const url = new URLSearchParams(currentSearch);
    url.set(query, value); // replaces or adds branch=0

    navigate(`${currentPath}?${url.toString()}`);
  };

  return (
    <div className="w-full h-full flex flex-col bg-backgroundColor">
      <CreateWoModal
        order={null}
        onSubmitClicked={saveWO}
        shown={isCreateOpen}
        onCancelClicked={() => setIsCreateOpen(false)}
      />
      <div className="px-5 py-2 border-b border-borderColor">
        <BranchBar />
        {/* {(isManagerOver() || isAccountant()) && 
        } */}
      </div>
      {branch !== 0 && (
        <div className="w-full flex items-center gap-8 justify-end py-[20px] px-[18px]" data-tour="wo-toolbar">
          {/* Filter button */}
          <Button onClicked={() => setFilterOpen(!filterOpen)} title="Filter" isHighlighted={filterOpen} dataTour="wo-filter" />
          {/* Download button */}
          {filterOpen && <DownloadButton isLoading={isDownloading} onClicked={downloadExcelFile} />}
          {/* Create  button */}
          {can("wo:create") && <CreateButton onClicked={() => setIsCreateOpen(true)} title="Create" testId="wo-create" dataTour="wo-create" />}
        </div>
      )}
      <div className="px-5 flex-1 min-h-0 flex flex-col py-5">
        {filterOpen && branch !== 0 && (
          <WOFitlerView
            apply={(data) => {
              appendBranchParam("criteria", JSON.stringify(data));
            }}
            clear={() => localStorage.removeItem("WO_CRITERIA")}
          />
        )}
        <WoTable
          data={orderArray}
          keyword={keyword}
          branch={branch}
          loadMore={handleLoadMore}
          loadMoreButtonShown={loadMoreButtonShown}
          restoring={restoring}
          deleteSuccess={(index) => {
            let temp = _.cloneDeep(orderArray);
            temp.splice(index, 1);
            setOrderArray(temp);
          }}
          sort={(data) => setSort(data)}
        />
      </div>
    </div>
  );
}

export default WO;
